import React, { useState } from 'react';
import logo from './logo.svg';
import './App.scss';
import { Breadcrumb, Input, Layout, Menu, theme } from 'antd';
import { Select, Spin } from "antd";
import { EnvironmentOutlined, DownOutlined, SearchOutlined } from "@ant-design/icons";
import { searchLocation } from './services/locationService';
import AppFooter from './Footer/Footer';
import Home from './HomePage/Home';
import Explore from './HomePage/Explore';
import { Routes, Route, useNavigate } from "react-router-dom";
import UserHomePage from './User/UserHomepage';
import RestaurantHome from './Restaurant/RestaurantHome';
import Checkout from './Checkout/Checkout';

const { Option } = Select;

const { Header, Content, Footer } = Layout;


function App() {

  const [options, setOptions] = useState<{ title: string; value: string }[]>([]);
  const [fetching, setFetching] = useState(false);
  const [value, setValue] = useState<string>();
  const navigate = useNavigate();

  const handleSearch = async (query: string) => {
    if (!query) {
      setOptions([]);
      return;
    }
    setFetching(true);
  const locations = await searchLocation({address:query})
  
  setOptions(locations?.data ?? []);
  setFetching(false);
  };

  const handleSelect = (val: string) => {
    setValue(val);
  };
  return (
    <Layout>
    <Header
    className='nav-head'
    >
      
       <div className="logo-header">
              <img className='pointer' src="/logo.svg" alt="Logo" onClick={()=>navigate('/')}/>

              <Select
        showSearch
        value={value}
        placeholder="Search location"
        filterOption={false}
        onSearch={handleSearch}
        onSelect={()=>handleSelect}
        notFoundContent={fetching ? <Spin size="small" /> : null}
        style={{ width: "200px"}}
        className='location-select'
        suffixIcon={<DownOutlined />} // dropdown icon on right
        optionLabelProp="label" // so input text shows label not value
        allowClear
        prefix={<EnvironmentOutlined />} // does not exist in Select directly, use custom render below
      >
        {options.map((opt) => (
          <Option key={opt.value} value={opt.value} label={opt.title}>
           
            {opt.title}
          </Option>
        ))}
      </Select>
            </div>
      <div className='login-head'>
        <div className='login-head'>
      <Input addonBefore={<SearchOutlined />} placeholder="Search" 
      className='header-search'
      style={{ width: "200px" }}/>
      </div>
      <div>Are you a Business?</div>
      <div>Get the app</div>
      <div className='pointer' onClick={()=>navigate('/user')}>Login</div>
      </div>
    </Header>
    <Content>
    <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/explore" element={<Explore />} />
          <Route path="/user" element={<UserHomePage/>} />
          <Route path="/restaurant/:id" element={<RestaurantHome/>} />
          <Route path="/checkout" element={<Checkout/>} />
        </Routes>
    </Content>
    <AppFooter/>
  </Layout>
  );
}

export default App;
